export * from './IconToolsCurveHold';
